import React from 'react'
import { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title } from 'chart.js';
import {  Bar } from 'react-chartjs-2';
import API from '../utils/api.js'
import { formatearNumero } from '../utils/FormatearNumero.js';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title);




const data_inicio_bar = {
  labels: ['Sin resultados'],
  datasets: [
    {
      label: 'Ganancia Neta',
      data: [0],
      backgroundColor: 'rgba(53, 162, 235, 0.5)',
    },
  ],
};


const data_inicio_bar2 = {
  labels: ['Sin resultados'],
  datasets: [
    {
      label: 'Cantidad Prestamos',
      data: [0],
      backgroundColor:  'rgba(255, 99, 132, 0.2)',
    },
  ],
};

const InformeVentas = () => {

    
  const [inversion, setInversion] = useState(0)
  const [cantidadPrestamos, setCantidadPrestamos] = useState(0)
  const [gananciaBruta, setGananciaBruta] = useState(0)
  const [gananciaNeta, setGananciaNeta] = useState(0)
  const [config, setConfig] = useState({})
  const [dashPrestamo, setDashPrestamo] = useState([])
  const [prestamosMes, setPrestamosMes] = useState([])
  const [dataBar, setDataBar] = useState(data_inicio_bar)
  const [dataBar2, setDataBar2] = useState(data_inicio_bar2)

  var url = API.urlAPI
  const urlDash = url + "ventas/dashventas"
  const urlPrestamosMes = url + "ventas/ventasxMes"

  const optionsBar = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      }
    }
  };

  
  const fetchDataBarra = async() => {
    let resp = await fetch(urlPrestamosMes)
    let dataBarra = await resp.json()

  let modeloBar = {
    labels: dataBarra.map((data) => data.Mes),
    datasets: [
      {
        label: 'Ventas por mes',
        data: dataBarra.map((data) => data.ImporteTotal),
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ]
  };
  setDataBar(modeloBar)

  }


  
  const fetchDataBarra2 = async() => {
    let resp = await fetch(urlPrestamosMes)
    let dataBarra = await resp.json()

  let modeloBar2 = {
    labels: dataBarra.map((data) => data.Mes),
    datasets: [
      {
        label: 'Cantidad de ventas por mes',
        data: dataBarra.map((data) => data.CantVentas),
        backgroundColor:  'rgba(255, 99, 132, 0.2)',
      },
    ]
  };
  setDataBar2(modeloBar2)

  }


  const fetchDataDash = async() => {
    let res = await fetch(urlDash)
    let data = await res.json()
    setInversion(data.map((item) => { return item.Inversion }))
    setCantidadPrestamos(data.map((item) => { return item.CantVentas }))
    setGananciaBruta(data.map((item) => { return item.GananciaBruta }))
    setGananciaNeta(data.map((item) => { return item.GananciaNeta }))
  }


  useEffect(() => {
    fetchDataDash()
    fetchDataBarra()
    fetchDataBarra2()
  }, [])
  return (
    <>
      <br></br>

      <div className="row">
    
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-primary shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                    Cantidad de ventas</div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">{Number(cantidadPrestamos)}</div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-shopping-basket fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-success shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                    Inversión / Capital</div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">${formatearNumero(Number(inversion))}</div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-success shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                    Ganancia Bruta</div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">${formatearNumero(Number(gananciaBruta))}</div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-success shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                    Ganancia Neta</div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">${formatearNumero(Number(gananciaNeta))}</div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div className="row">
        <div className="col-xl-8 col-lg-7">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between bg-primary">
              <h6 className="m-0 font-weight-bold text-white">Ganancia neta por mes</h6>

            </div>
            <div className="card-body">
              <div style={{ height: 350 }}>
            
              <Bar options={optionsBar} data={dataBar} />
              </div>

            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-5">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between bg-primary">
              <h6 className="m-0 font-weight-bold text-white">Cantidad ventas por mes</h6>

            </div>
            <div className="card-body">
              <div style={{ height: 350 }}>
                <Bar options={optionsBar} data={dataBar2} />
              </div>

            </div>
          </div>
        </div>


      </div>
    </>
  )
}

export default InformeVentas